// SubscriptionOverlay.js (updated)
import { FaLock, FaArrowRight, FaTimes } from 'react-icons/fa';
import { motion } from 'framer-motion';

const SubscriptionOverlay = ({ onUnlockClick, onClose }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-50"
    >
      <motion.div
        initial={{ scale: 0.9, y: 20 }}
        animate={{ scale: 1, y: 0 }}
        exit={{ scale: 0.9, y: 20 }}
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full"
      >
        <div className="p-6 relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          >
            <FaTimes />
          </button>

          <div className="flex justify-center mb-6">
            <div className="bg-blue-100 p-4 rounded-full">
              <FaLock className="text-blue-600 text-4xl" />
            </div>
          </div>

          <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
            Unlock Full Access to Miles2Go
          </h2>

          <p className="text-gray-600 mb-6 text-center">
            To start searching flights across countries, please choose a subscription plan.
          </p>

          <div className="bg-blue-50 rounded-lg p-4 mb-6">
            <h3 className="font-bold text-blue-800 mb-2">Why Subscribe?</h3>
            <ul className="text-left list-disc list-inside text-gray-700 space-y-1">
              <li>Compare reward flights across all major airlines</li>
              <li>Find the best redemption options for your points</li>
              <li>Get access to exclusive flight deals</li>
              <li>Save thousands of rupees on every trip</li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={onUnlockClick}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg shadow-md flex items-center justify-center transition-all"
            >
              View Plans <FaArrowRight className="ml-2" />
            </button>
            
            <button
              onClick={onClose}
              className="bg-white border border-blue-600 text-blue-600 font-medium py-3 px-6 rounded-lg shadow-sm flex items-center justify-center transition-all hover:bg-blue-50"
            >
              Explore First
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default SubscriptionOverlay;